import React, { useContext, useEffect, useState } from "react";
import { controller, endpoints } from "../../../api/actions/api";
import * as actions from "../../../api/actions/actions";
import { connect } from "react-redux";
import { AppContext } from "../../../App";
import RepNav from "./RepNav";
import { Table } from "../../../layout";
import moment from "moment";
import { DropLi } from "../../../hooks";

const tblHeader = () => (
  <div className="d-flex a-center flex-wrap">
    <h2 className="border-left h fw-4 fs-16 gray-color tx-upp">Vendor Info</h2>
  </div>
);

const VendorInfo = (props) => {
  const { _getById, _hoa } = props;
  const { setLoader } = useContext(AppContext);
  const [csvHeader, setCsvHeader] = useState([]);
  const [tblData, setTblData] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [sortDate, setSortDate] = useState({
    fromDate: `1/1/${new Date().getFullYear()}`,
    toDate: `12/31/${new Date().getFullYear()}`,
  });

  const { Countries } = DropLi();

  useEffect(() => {
    setCsvHeader([
      { label: "Account Number", key: "accNumber" },
      { label: "Vendor Name", key: "name" },
      { label: "Contact Name", key: "contactName" },
      { label: "Nickname", key: "nickname" },
      { label: "Email", key: "contactEamil" },
      { label: "Phone", key: "phone" },
      { label: "Fax", key: "fax" },
      { label: "Website", key: "website" },
      { label: "Address", key: "address" },
      { label: "City", key: "city" },
      { label: "State", key: "state" },
      { label: "ZIP", key: "zip" },
      { label: "Country", key: "country" },
      { label: "Created At", key: "createDate" },
    ]);
    return () => {
      setCsvHeader([]);
    };
  }, []);
  useEffect(() => {
    setTblData([
      ...filteredData.map((j) => {
        var country = Countries.find((x) => x.id === j.country);
        return {
          ...j,
          address: `${j.address1} | ${j.address2}`,
          country: country && country.name,
        };
      }),
    ]);
    return () => {
      setTblData([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredData]);

  useEffect(() => {
    if (_hoa.id) {
      setLoader(true);
      const onComplete = (res) => {
        setLoader(false);
        if (res.status === 200) {
          setVendors(res.result);
          setFilteredData(res.result);
        }
      };
      _getById(
        endpoints.Vendor + controller.GetByHoa,
        _hoa.id,
        null,
        onComplete
      );
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_hoa]);

  useEffect(() => {
    vendors &&
      setFilteredData([
        ...vendors.filter(
          (j) =>
            moment(j.createDate, "MM/DD/YYYY") >=
              moment(sortDate.fromDate, "MM/DD/YYYY") &&
            moment(j.createDate, "MM/DD/YYYY") <=
              moment(sortDate.toDate, "MM/DD/YYYY")
        ),
      ]);

    return () => {
      setFilteredData([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendors, sortDate]);

  return (
    <>
      <div className="mt-20 mb-10">
        <RepNav
          {...{
            csvHeader,
            csvData: tblData,
            sortDate,
            setSortDate,
            title: "Vendor Info",
            showTitle: false,
          }}
        />
      </div>
      <div>
        <Table
          shadow={false}
          ActionComp={() => <></>}
          HeaderComp={tblHeader}
          tblHead={[
            { id: "accNumber", label: "Account Number" },
            { id: "name", label: "Vendor Name" },
            { id: "contactName", label: "Contact Name" },
            { id: "nickname", label: "Nickname" },
            { id: "contactEamil", label: "Email" },
            { id: "phone", label: "Phone" },
            { id: "fax", label: "Fax" },
            { id: "website", label: "Website" },
            { id: "address", label: "Address" },
            { id: "city", label: "City" },
            { id: "state", label: "State" },
            { id: "zip", label: "ZIP" },
            { id: "country", label: "Country" },
            { id: "createDate", label: "Created At" },
          ]}
          tblData={tblData}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  _hoa: state.storeData.defHoa,
});

const mapActionToProps = {
  _getById: actions.getById,
  _delete: actions.Delete,
};

export default connect(mapStateToProps, mapActionToProps)(VendorInfo);
